// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1vy_F","row":"Node_row__2FDCV","label":"Node_label__2ApvB","footer":"Node_footer__1Mc7G"};